export default "__VITE_ASSET__Dlc$VkyU__"